var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "claim-row-paid",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4 C13.5522847,4 14,4.44771525 14,5 L14,19 C14,19.5522847 13.5522847,20 13,20 L1,20 C0.44771525,20 -1.27830057e-13,19.5522847 -1.27897692e-13,19 L-1.27897692e-13,5 C-1.27965328e-13,4.44771525 0.44771525,4 1,4 L13,4 Z M7,16 L2,16 L2,17 L7,17 L7,16 Z M11,14 L2,14 L2,15 L11,15 L11,14 Z M12,12 L2,12 L2,13 L12,13 L12,12 Z M7,7 L2,7 L2,8 L7,8 L7,7 Z",
    id: "Shape",
    fill: "#B2F2BB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#69DB7C",
    cx: 14,
    cy: 7,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.18,6.38888889 C12.818,6.06111111 12.38,5.72222222 12.38,5.19444444 C12.38,4.58888889 12.986,4.16666667 14,4.16666667 C14.852,4.16666667 15.278,4.46666667 15.434,4.94444444 C15.506,5.16666667 15.704,5.33333333 15.956,5.33333333 L16.136,5.33333333 C16.532,5.33333333 16.814,4.97222222 16.676,4.62777778 C16.424,3.97222222 15.836,3.42777778 14.9,3.21666667 L14.9,2.83333333 C14.9,2.37222222 14.498,2 14,2 C13.502,2 13.1,2.37222222 13.1,2.83333333 L13.1,3.2 C11.936,3.43333333 11,4.13333333 11,5.20555556 C11,6.48888889 12.146,7.12777778 13.82,7.5 C15.32,7.83333333 15.62,8.32222222 15.62,8.83888889 C15.62,9.22222222 15.326,9.83333333 14,9.83333333 C13.01,9.83333333 12.5,9.50555556 12.302,9.03888889 C12.212,8.82222222 12.008,8.66666667 11.762,8.66666667 L11.594,8.66666667 C11.192,8.66666667 10.91,9.04444444 11.06,9.38888889 C11.402,10.1611111 12.2,10.6166667 13.1,10.7944444 L13.1,11.1666667 C13.1,11.6277778 13.502,12 14,12 C14.498,12 14.9,11.6277778 14.9,11.1666667 L14.9,10.8055556 C16.07,10.6 17,9.97222222 17,8.83333333 C17,7.25555556 15.542,6.71666667 14.18,6.38888889 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowPaid);
export default __webpack_public_path__ + "static/media/claim-row-paid.e49c0357a50ac3e11c10e7c8fbe53b6b.svg";
export { ForwardRef as ReactComponent };